import React, { useContext } from 'react';
import {
    BrowserRouter,
    Routes,
    Route
}
    from 'react-router-dom'
import { ClientNavigator } from '../../navigator/client.navigator';
import { DashboardScreen } from '../common/dashboard.screen';
import { LoginScreen } from '../admin/login.screen';
import { UserContext } from '../../App';
import { SignInScreen } from '../common/sign_in.screen';
export const ClientApp = () => {

    const { user } = useContext(UserContext);
    return <BrowserRouter
        future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
        }}
    >
        <Routes>
            {user.id ?
                <Route path="/" element={<DashboardScreen navigator={ClientNavigator()} />}>
                    {ClientNavigator().filter(F => F.parent === undefined).map(M => <Route key={M.link} path={`${M.link}`} element={M.page} />)}
                </Route> : [
                    <Route key="sign-in" path="/sign-in" element={<SignInScreen />} />,
                    <Route key="fallback" path="/*" element={<LoginScreen />} />,
                ]}
        </Routes>
    </BrowserRouter>
}
